// extracted by mini-css-extract-plugin
export default {"cls1":"RaNVuXjf7PlGEkY2gVwO","cls2":"YHvNa8ncAOFV7vj4EdE1 RaNVuXjf7PlGEkY2gVwO","bookingAppRedesign":"Gm5hxy_BQboWve2O7V3e"};